// @flow
import React, { Fragment } from "react";

import type { $SiteOfficeBroker } from "flow/types";

type $Props = {
  broker: $SiteOfficeBroker,
};

const BrokerUrl = ({ broker }: $Props) => (
  <Fragment>
    {broker.url && (
      <div>
        <a href={broker.url} target="_blank" rel="noopener noreferrer">
          {broker.url}
        </a>
      </div>
    )}
  </Fragment>
);

export default BrokerUrl;
